import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { ArrowRightAlt } from '@material-ui/icons';
import Divider from "@material-ui/core/Divider";
import { useEffect, useState } from "react";
import { enums } from "../../enums/enums";
import { format, isValid  } from "date-fns";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { ICliente } from '../../entities/catalogos/ICliente';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            '& td': {
                paddingLeft: "0"
            }
        },
        header: {
            boxSizing: "border-box",
            height: "60.52px",
            backgroundColor: "#F7F7F7",
            boxShadow: "0 2px 14px 0 rgba(0,0,0,0.08)"
        },
        mainTitle: {
            color: "#19754e",
            fontSize: "20px"
        },
        title: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "2em",
                paddingBottom: "0.2em"
            }
        },
        information: {
            color: "#212121",
            fontSize: "14px",
            fontWeight: 500
        },
        additional: {
            color: " rgba(49,49,49,0.87)",
            fontSize: "12px"
        }
    }),
);

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    cliente: ICliente
}

type Props = StateProps

let recoleccionConversion = {
    0: "",
    [enums.tipoRecoleccion.ocurre]: traducirLabel(288),//"Sucursal",
    [enums.tipoRecoleccion.comercial]: traducirLabel(44),//"Comercio",
    [enums.tipoRecoleccion.residencial]: traducirLabel(103),//"Domicilio",
};

const Resumen = ({ solicitud, solicitudCopia, cliente }: Props) => {
    const classes = useStyles();



    const [formaEnvio, setFormaEnvio] = useState("");
    const [entrega, setEntrega] = useState("");
    const [fechaRad, setFechaRad] = useState("");
    const [fechaEad, setFechaEad] = useState("");
    const [tipoSeguro, setTipoSeguro] = useState("");

    useEffect(() => {


        const tipoRecoleccionOrigenId = solicitud.tipoRecoleccionIdOrigen ? solicitud.tipoRecoleccionIdOrigen : 0;
        const tipoRecoleccionDestinoId = solicitud.tipoRecoleccionIdDestino ? solicitud.tipoRecoleccionIdDestino : 0;
        let seguro = solicitud.esSeguroBasico ? traducirLabel(273) : solicitud.esSeguroMercancia ? traducirLabel(274) : "";

        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.ocurre){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(288)}`);
        }
        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.comercial){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(44)}`);
        }
        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.residencial){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(103)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.ocurre){
            setEntrega(traducirLabel(115)+` ${traducirLabel(288)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.comercial){
            setEntrega(traducirLabel(115)+` ${traducirLabel(44)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.residencial){
            setEntrega(traducirLabel(115)+` ${traducirLabel(103)}`);
        }
        let language = 'es';
        if (solicitud.id == 0) {

            setFechaRad(solicitud.fechaCitaRad ? format(solicitud.fechaCitaRad, 'dd MMM yyyy h:mm a') : "");
            setFechaEad(solicitud.fechaCitaEad ? format(solicitud.fechaCitaEad, 'dd MMM yyyy h:mm a') : "");

            if(solicitud.fechaCitaRad === undefined){
                if(!solicitud.fechaCitaRadCedis || solicitud.fechaCitaRadCedis instanceof Date && solicitud.fechaCitaRadCedis.getFullYear() === 1){
                    setFechaRad("");
                }else{
                    setFechaRad(solicitud.fechaCitaRadCedis ? format(solicitud.fechaCitaRadCedis, 'dd MMM yyyy h:mm a') : "");
                }
                
            }
            if(solicitud.fechaCitaEad === undefined){
                if(!solicitud.fechaCitaEadCedis || solicitud.fechaCitaEadCedis instanceof Date && solicitud.fechaCitaEadCedis.getFullYear() === 1){
                    setFechaEad("");
                }else{
                    setFechaEad(solicitud.fechaCitaEadCedis ? format(solicitud.fechaCitaEadCedis, 'dd MMM yyyy h:mm a') : "");
                }
            }
        }
        else {
            setFechaRad(solicitud.fechaCitaRad ? `${new Date(solicitud.fechaCitaRad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
            setFechaEad(solicitud.fechaCitaEad ? `${new Date(solicitud.fechaCitaEad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
            
            if(solicitud.fechaCitaRad === undefined){
                if(!solicitud.fechaCitaRadCedis || solicitud.fechaCitaRadCedis instanceof Date && solicitud.fechaCitaRadCedis.getFullYear() === 1){
                    setFechaRad("");
                }else{
                    setFechaRad(solicitud.fechaCitaRadCedis ? `${new Date(solicitud.fechaCitaRadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                }
                
            }
            if(solicitud.fechaCitaEad === undefined){
                if(!solicitud.fechaCitaEadCedis || solicitud.fechaCitaEadCedis instanceof Date && solicitud.fechaCitaEadCedis.getFullYear() === 1){
                    setFechaEad("");
                }else{
                    setFechaEad(solicitud.fechaCitaEadCedis ? `${new Date(solicitud.fechaCitaEadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                }
            }

            /*
            if(solicitud.fechaCitaRad === undefined)
                setFechaRad(solicitud.fechaCitaRadCedis ? `${new Date(solicitud.fechaCitaRadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
            if(solicitud.fechaCitaEad === undefined)
                setFechaEad(solicitud.fechaCitaEadCedis ? `${new Date(solicitud.fechaCitaEadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
            */
        }
        if(localStorage.getItem("idioma")==='en-US'){
            language = 'en';
            if (solicitud.id == 0) {

            setFechaRad(solicitud.fechaCitaRad ? format(solicitud.fechaCitaRad, 'dd MMM yyyy h:mm a') : "");
            setFechaEad(solicitud.fechaCitaEad ? format(solicitud.fechaCitaEad, 'dd MMM yyyy h:mm a') : "");

            if(solicitud.fechaCitaRad === undefined){
                if(!solicitud.fechaCitaRadCedis || solicitud.fechaCitaRadCedis instanceof Date && solicitud.fechaCitaRadCedis.getFullYear() === 1){
                    setFechaRad("");
                }else{
                    setFechaRad(solicitud.fechaCitaRadCedis ? format(solicitud.fechaCitaRadCedis, 'dd MMM yyyy h:mm a') : "");
                }
                
            }
            if(solicitud.fechaCitaEad === undefined){
                if(!solicitud.fechaCitaEadCedis || solicitud.fechaCitaEadCedis instanceof Date && solicitud.fechaCitaEadCedis.getFullYear() === 1){
                    setFechaEad("");
                }else{
                    setFechaEad(solicitud.fechaCitaEadCedis ? format(solicitud.fechaCitaEadCedis, 'dd MMM yyyy h:mm a') : "");
                }
            }
            }
            else {
                setFechaRad(solicitud.fechaCitaRad ? `${new Date(solicitud.fechaCitaRad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                setFechaEad(solicitud.fechaCitaEad ? `${new Date(solicitud.fechaCitaEad).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");

                if(solicitud.fechaCitaRad === undefined){
                    if(!solicitud.fechaCitaRadCedis || solicitud.fechaCitaRadCedis instanceof Date && solicitud.fechaCitaRadCedis.getFullYear() === 1){
                        setFechaRad("");
                    }else{
                        setFechaRad(solicitud.fechaCitaRadCedis ? `${new Date(solicitud.fechaCitaRadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                    }
                    
                }
                if(solicitud.fechaCitaEad === undefined){
                    if(!solicitud.fechaCitaEadCedis || solicitud.fechaCitaEadCedis instanceof Date && solicitud.fechaCitaEadCedis.getFullYear() === 1){
                        setFechaEad("");
                    }else{
                        setFechaEad(solicitud.fechaCitaEadCedis ? `${new Date(solicitud.fechaCitaEadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                    }
                }
                /*
                if(solicitud.fechaCitaRad === undefined)
                    setFechaRad(solicitud.fechaCitaRadCedis ? `${new Date(solicitud.fechaCitaRadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
                if(solicitud.fechaCitaEad === undefined)
                    setFechaEad(solicitud.fechaCitaEadCedis ? `${new Date(solicitud.fechaCitaEadCedis).toLocaleString(language, { day: "numeric", month: "short", year: "numeric", hour: 'numeric', minute: 'numeric', hour12: true })}` : "");
*/
            }
        }

        if(solicitud.esSeguroBasico){
            setTipoSeguro(traducirLabel(273));
        }
        else{
            if(solicitud.esSeguroMercancia){
                setTipoSeguro(traducirLabel(274));
            }
            else{
                setTipoSeguro('');
            }
        }

    }, [solicitud]);

    return (<>


        <Paper>
            <Box className={classes.header} display="flex" alignItems="center">
                <Box className={classes.mainTitle} px={3}>
                    {/* Resumen */traducirLabel(264)}
                </Box>
            </Box>

            <Box px={3} pb={2}>
                <Box display="flex" flexWrap="wrap">
                    <table className={classes.root}>
                        <tbody>
                            {cliente.habilitarClienteLogistico &&
                                <tr className={classes.title}>
                                    <td style={{ width: "45%" }}>
                                        {/* FACTURADOR */traducirLabel(127)}
                                    </td>
                                    <td style={{ width: "10%" }} />
                                    <td style={{ width: "45%" }} className={classes.information}>{solicitud.facturador?.clienteNombre}</td>
                                </tr>
                            }

                            {cliente.grupoClienteID >= 0 && (cliente.clienteCreditoProyecto && cliente.clienteCreditoProyecto?.length >= 2) &&
                                <tr className={classes.title}>
                                    <td style={{ width: "45%" }}>
                                        {/* PROYECTO */traducirLabel(241)}
                                        </td>
                                    <td style={{ width: "10%" }} />
                                    <td style={{ width: "45%" }} className={classes.information}>{solicitud.proyecto ? solicitud.proyecto?.descripcion : solicitudCopia.proyecto?.descripcion}</td>
                                </tr>
                            }
                            <tr className={classes.title}>
                                <td style={{ width: "45%" }}>
                                    {/* ORIGEN */traducirLabel(222)}
                                    </td>
                                <td style={{ width: "10%" }} />
                                <td style={{ width: "45%" }}>
                                    {/* DESTINO */traducirLabel(86)}
                                </td>
                            </tr>

                            <tr style={{ fontSize: "14px", color: "rgba(0,0,0,0.87)", fontWeight: 500 }}>
                                {solicitud.coloniaOrigen &&
                                    <td style={{ width: "45%" }}>
                                        <div style={solicitud.esDetalle == true ? { maxWidth: "320px", overflowWrap: 'break-word' } : { maxWidth: "120px", overflowWrap: 'break-word' }}>
                                            {solicitud.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.ocurre ?
                                                `${solicitud.sucursalOrigen?.estado?.nombre} ${solicitud.sucursalOrigen?.ciudad?.nombre}`
                                                : solicitud.esDetalle === true ?
                                                    `${solicitud.direccionRemitente}`
                                                    : `${solicitud.coloniaOrigen?.codigoPostal} ${solicitud.sucursalOrigen?.ciudad?.nombre ?? ""} ${solicitud.sucursalOrigen?.estado?.nombre ?? ""}`}
                                        </div>
                                    </td>

                                }
                                {solicitud.coloniaOrigen &&
                                    <td style={{ width: "10%" }}><ArrowRightAlt style={{ verticalAlign: "middle" }} /></td>
                                }
                                {solicitud.coloniaDestino &&
                                    <td style={{ width: "45%" }}>
                                        <div style={solicitud.esDetalle == true ? { maxWidth: "320px", overflowWrap: 'break-word' } : { maxWidth: "120px", overflowWrap: 'break-word' }}>
                                            {solicitud.coloniaDestino && solicitud.tipoRecoleccionIdDestino === enums.tipoRecoleccion.ocurre ?
                                                `${solicitud.sucursalDestino?.estado?.nombre} ${solicitud.sucursalDestino?.ciudad?.nombre}`
                                                : solicitud.esDetalle === true ?
                                                    `${solicitud.direccionDestinatario}` :
                                                    `${solicitud.coloniaDestino?.codigoPostal !== undefined ? solicitud.coloniaDestino?.codigoPostal
                                                        : solicitud.coloniaDestino?.codigoPostal} ${solicitud.sucursalDestino?.ciudad?.nombre ?? ""} ${solicitud.sucursalDestino?.estado?.nombre ?? ""}`}

                                        </div>
                                    </td>
                                }
                            </tr>

                            <tr style={{ fontSize: "13px", color: "rgba(0,0,0,0.87)", fontWeight: 700, paddingTop: "5px" }}>
                                {solicitud.contactoOrigen &&
                                    <td style={{ width: "45%" }}>
                                        <div style={{ maxWidth: "120px", overflowWrap: 'break-word' }}>
                                            {solicitud.contactoOrigen.nombre}
                                        </div>

                                    </td>

                                }
                                <td style={{ width: "10%" }}></td>
                                {solicitud.contactoDestino &&
                                    <td style={{ width: "45%" }}>
                                        <div style={{ maxWidth: "120px", overflowWrap: 'break-word' }}>
                                            {solicitud.contactoDestino.nombre}
                                        </div>

                                    </td>
                                }
                            </tr>
                            <tr style={{ fontSize: "11px", color: "rgba(0,0,0,0.87)", fontWeight: 600 }}>
                                {solicitud.contactoOrigen &&
                                    <td style={{ width: "45%" }}>
                                        <div style={{ width: "150px", wordBreak: "break-all" }}> {solicitud.contactoOrigen.correo}</div>

                                    </td>


                                }
                                <td></td>
                                {solicitud.contactoDestino &&
                                    <td style={{ width: "45%" }}>
                                        <div style={{ width: "150px", wordBreak: "break-all" }}>{solicitud.contactoDestino?.correo}</div>

                                    </td>
                                }
                            </tr>
                            <tr style={{ fontSize: "11px", color: "rgba(0,0,0,0.87)", fontWeight: 600 }}>
                                {solicitud.contactoOrigen &&
                                    <td style={{ width: "45%" }}>
                                        {solicitud.contactoOrigen.telefono}
                                    </td>

                                }
                                <td></td>
                                {solicitud.contactoDestino &&
                                    <td style={{ width: "45%" }}>
                                        {solicitud.contactoDestino?.telefono}
                                    </td>
                                }


                            </tr>


                            {solicitudCopia.tipoRecoleccionIdOrigen &&
                                <>
                                    <tr className={classes.title}>
                                        <td>
                                            {/* FORMA DE ENVÍO */
                                            traducirLabel(142)}
                                            </td>
                                        <td />
                                        <td>
                                            {/* ENTREGA */traducirLabel(114)}
                                        </td>
                                    </tr>

                                    <tr className={classes.information}>
                                        <td>{formaEnvio}</td>
                                        <td />
                                        <td>{entrega ? entrega : ""}</td>
                                    </tr>
                                </>
                            }

                            <tr>
                                <td>

                                    <table>
                                        <tr className={classes.additional}>
                                            <td style={{ verticalAlign: "top" }}>
                                                <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                    {solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !== 3 && fechaRad && (!solicitud.EsRadCitaFueraHorario && <li>{fechaRad.toString().substr(0, 11)}</li> || solicitud.EsRadCitaFueraHorario && <li>{fechaRad.toString().substr(0, 11) + " " + solicitud.RadCitaHoraDe + " - " + solicitud.RadCitaHoraHasta}</li>)}

                                                    {localStorage.getItem("idioma") === 'en-US' && solicitud.serviciosAdicionalesOrigen?.map(sa =>

                                                        solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA RAD' && solicitud.fechaCitaRad && !solicitud.EsRadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO RAD FUERA DE HORARIO' && solicitud.fechaCitaRad && solicitud.EsRadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id}   >{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}</li> : null
                                                    )
                                                    }
                                                    {localStorage.getItem("idioma") !== 'en-US' && solicitud.serviciosAdicionalesOrigen?.map(sa =>

                                                        solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA RAD' && solicitud.fechaCitaRad && !solicitud.EsRadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO RAD FUERA DE HORARIO' && solicitud.fechaCitaRad && solicitud.EsRadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id}   >{sa.nombre}</li> : null
                                                    )
                                                    }
                                                </ul>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td></td>
                                <td>
                                    <table>

                                        <tr className={classes.additional}>
                                            <td style={{ verticalAlign: "top" }}>
                                                <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                    {solicitud.tipoRecoleccionIdDestino !== undefined && solicitud.tipoRecoleccionIdDestino !== 3 && fechaEad && (!solicitud.EsEadCitaFueraHorario && <li>{fechaEad.toString().substr(0, 11)}</li> || solicitud.EsEadCitaFueraHorario && <li>{fechaEad.toString().substr(0, 11) + " " + solicitud.EadCitaHoraDe + " - " + solicitud.EadCitaHoraHasta}</li>)}

                                                    {localStorage.getItem("idioma") === 'en-US' && solicitud.serviciosAdicionalesDestino?.map(sa =>
                                                        solicitud.tipoRecoleccionIdDestino !== undefined && solicitud.tipoRecoleccionIdDestino !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA EAD' && solicitud.fechaCitaEad && !solicitud.EsEadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO EAD FUERA DE HORARIO' && solicitud.fechaCitaEad && solicitud.EsEadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id}   >{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}</li> : null

                                                    )
                                                    }
                                                    {localStorage.getItem("idioma") !== 'en-US' && solicitud.serviciosAdicionalesDestino?.map(sa =>
                                                        solicitud.tipoRecoleccionIdDestino !== undefined && solicitud.tipoRecoleccionIdDestino !== 3 && sa.seleccionado !== undefined && ((sa.nombre == 'CARGO POR CITA EAD' && solicitud.fechaCitaEad && !solicitud.EsEadCitaFueraHorario) || (sa.nombre == 'FLETE CARGO EAD FUERA DE HORARIO' && solicitud.fechaCitaEad && solicitud.EsEadCitaFueraHorario)) || sa.seleccionado ? <li key={sa.id}   >{sa.nombre}</li> : null

                                                    )
                                                    }
                                                </ul>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>



                        </tbody>
                    </table>
                </Box>

                <Box display="flex" flexDirection="column" style={{ textAlign: "left" }}>
                    {solicitudCopia.tipoServicio &&
                        <>
                            <Box className={classes.title}>
                                {/* SERVICIO */traducirLabel(276)}
                            </Box>
                            <Box className={classes.information}>
                                {solicitudCopia.tipoServicio?.nombre}
                            </Box>
                        </>
                    }

                    {solicitud.cruceFronterizo &&
                        <>
                            <Box className={classes.title}>
                                {/* CRUCE */
                                    traducirLabel(345)}
                            </Box>
                            <Box className={classes.information}>
                                {solicitud.cruceFronterizo?.cruce}
                            </Box>
                        </>
                    }

                    {solicitudCopia.tipoEnvio &&
                        <>
                            <Box className={classes.title}>
                                {/* ENVÍO */traducirLabel(122)}
                            </Box>

                            <Box className={classes.information} mb={2}>
                                {solicitudCopia.tipoEnvio?.nombre}
                            </Box>
                        </>
                    }

                    {cliente.esClase == true &&
                        <>
                            <Box className={classes.title}>
                                {/* Clase */
                                    traducirLabel(34)}
                            </Box>

                            <Box className={classes.information}>
                                {typeof solicitud.clase == "string" ? solicitud.clase : ''}
                            </Box>
                        </>
                    }

                    <Divider light />

                    {(solicitudCopia.serviciosAdicionales || tipoSeguro) &&
                        <>
                            <Box className={classes.title}>
                                {/* SERVICIOS ADICIONALES */traducirLabel(278)}
                            </Box>

                            <Box className={classes.information}>
                                {tipoSeguro}
                            </Box>

                            {localStorage.getItem("idioma") === 'en-US' && solicitudCopia.serviciosAdicionales?.map((sa, index) =>
                                <Box key={index} className={classes.information}>
                                    {(sa.etiquetaServicioAdicionalDto?.nombre == null || sa.etiquetaServicioAdicionalDto?.nombre === '') ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}
                                </Box>
                            )}
                            {localStorage.getItem("idioma") !== 'en-US' && solicitudCopia.serviciosAdicionales?.map((sa, index) =>
                                <Box key={index} className={classes.information}>
                                    {sa.nombre}
                                </Box>
                            )}
                        </>
                    }
                </Box>
            </Box>
        </Paper>



    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    cliente: state.cliente
});

export default connect(mapStateToProps)(Resumen);
